import { styled } from '@linaria/react';
import Image from 'next/image';
import { Button, CommentIcon, EffectsIcon, EyeOpenIcon, FolderIcon, HistoryIcon, ShareIcon, StarIcon, UsersOnIcon } from '@vidbaseapp/styleguide';
import { StyledLandingSection } from './LandingSection';
export const StyledLandingFeature = /*#__PURE__*/styled("article")({
  name: "StyledLandingFeature",
  class: "suj3xvr"
});
export const LandingFeatures = () => {
  return <StyledLandingSection className="features dotted " bg={'var(--clr-nav-shadow)'}>
			<div className="content">
				<div className="headline">
					<h1>Stop Juggling Between Slow Apps</h1>
					<p>
						Everything you need to refine your team's workflow and publish content faster in one
						place.
					</p>
				</div>
				<StyledLandingFeature id="featureUI">
					<div className="featureCol copy">
						<div className="copyContent">
							<h2>
								Pro Features,
								<br /> Made Easy.
							</h2>
							<p>
								Easy to learn with a forgiving interface. Advanced features, plugins, & tools are
								hidden away until you need them.
							</p>
							<ul>
								<li>
									<div className="icon">
										<HistoryIcon size="2.5rem" color="var(--clr-text)" />
									</div>
									<div className="featureLi">
										<h3>Multi-Paradigm Editing</h3>
										<p>
											Edit via timeline, transcript, outline, or cards. Switch anytime, keep your
											changes. No restarting from scratch if you make a mistake.
										</p>
									</div>
								</li>
								<li>
									<div className="icon">
										<EffectsIcon size="2.5rem" color="var(--clr-text)" />
									</div>
									<div className="featureLi">
										<h3>Professional Effects</h3>
										<p>
											Desktop-grade effects at your fingertips for color correction, parametric
											equalizers, &amp; more.
										</p>
									</div>
								</li>
							</ul>
							<div className="ctaLearnMore buttonWrap">
								<Button as="a" href="/features/ui" className="secondary">
									Learn more {'->'}
								</Button>
							</div>
						</div>
					</div>
					<div className="featureCol figure">
						<div className="figure-container">
							<div className="img-container">
								<Image src="/img/vidbase-screenshot.png" alt="A place for everything and everything in its place. " width="1024" height="576" priority />
							</div>
						</div>
					</div>
				</StyledLandingFeature>

				<StyledLandingFeature id="featureCollab" className="left">
					<div className="featureCol copy">
						<div className="copyContent">
							<h2>Content Editing, Simplified.</h2>
							<p>
								Powerful new editing tools allow creators to skip the boring busywork &amp; focus on
								being creative.
							</p>
							<ul>
								<li>
									<div className="icon">
										<CommentIcon size="2.5rem" color="var(--clr-text)" />
									</div>
									<div className="featureLi">
										<h3>Usable Transcripts, For Once</h3>
										<p>
											Best-in-class speech-to-text processing learns &amp; adapts to you over time.
											Tags people, places, objects, colors, &amp; more.
										</p>
									</div>
								</li>
								<li>
									<div className="icon">
										<EyeOpenIcon size="2.5rem" color="var(--clr-text)" />
									</div>
									<div className="featureLi">
										<h3>Instantly Find that Perfect Clip</h3>
										<p>
											Vidbase automatically tags, organizes, and indexes your media for incredibly
											fast &amp; flexible search. Customize it to fit your needs.
										</p>
									</div>
								</li>
								<li>
									<div className="icon">
										<StarIcon size="2.5rem" color="var(--clr-text)" className="filled" />
									</div>
									<div className="featureLi">
										<h3>A Magical Experience</h3>
										<p>
											Remove people, objects, and backgrounds with a touch. Remix 20 of your best
											takes into the perfect one. So much more.
										</p>
									</div>
								</li>
							</ul>
							<div className="ctaLearnMore buttonWrap">
								<Button as="a" href="/features/ml" className="secondary">
									Learn more {'->'}
								</Button>
							</div>
						</div>
					</div>
					<div className="featureCol figure">
						<div className="figure-container">
							<div className="img-container">
								<Image src="/img/vidbase-screenshot.png" alt="A place for everything and everything in its place. " width="1024" height="576" priority />
							</div>
						</div>
					</div>
				</StyledLandingFeature>

				<StyledLandingFeature id="featureCollab">
					<div className="featureCol copy">
						<div className="copyContent">
							<h2>
								Collaborate
								<br />
								in Real-Time.
							</h2>
							<p>
								Work together to explore ideas, share revisions, and review feedback. Iterate
								rapidly and publish the best content.
							</p>
							<ul>
								<li>
									<div className="icon">
										<FolderIcon size="2.5rem" color="var(--clr-text)" />
									</div>
									<div className="featureLi">
										<h3>Work Together Seamlessly</h3>
										<p>
											Your whole team can work on the same file at the same time. No more sharing
											files like 'wip_3020_rev1_edit2_final_FINAL'.
										</p>
									</div>
								</li>
								<li>
									<div className="icon">
										<ShareIcon size="2.5rem" color="var(--clr-text)" />
									</div>
									<div className="featureLi">
										<h3>Share with Ease</h3>
										<p>
											Collect feedback & edits on your draft with just a link. Or show off your
											timelines.
										</p>
									</div>
								</li>
								<li>
									<div className="icon">
										<UsersOnIcon size="2.5rem" color="var(--clr-text)" />
									</div>
									<div className="featureLi">
										<h3>Modernized Workflows</h3>
										<p>
											Sharing, comments, approvals, proxy files, asset libraries, branches,
											snapshots, shared export settings, and more.
										</p>
									</div>
								</li>
							</ul>
							<div className="ctaLearnMore buttonWrap">
								<Button as="a" href="/features/collab" className="secondary">
									Learn more {'->'}
								</Button>
							</div>
						</div>
					</div>
					<div className="featureCol figure">
						<div className="figure-container">
							<div className="img-container">
								<Image src="/img/vidbase-screenshot.png" alt="A place for everything and everything in its place. " width="1024" height="576" priority />
							</div>
						</div>
					</div>
				</StyledLandingFeature>
			</div>
		</StyledLandingSection>;
};

require("./LandingFeatures.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingFeatures.tsx");